import Validator from "./validator";
import {NumericComparison} from "../conditionalRules/numericComparison";

export default class NumericValidator extends Validator {
  static isValid(left, comparator: NumericComparison, right): boolean {
    switch (comparator) {
      case NumericComparison.isLessThan:
        return left < right;
      case NumericComparison.isGreaterThan:
        return left > right;
      case NumericComparison.isLessOrEqualTo:
        return left <= right;
      case NumericComparison.isGreaterOrEqualTo:
        return left >= right;
      case NumericComparison.isNotEqualTo:
        return left !== right;
      default:
        return left === right;
    }
  }
}